import { createSlice } from "@reduxjs/toolkit";
const personalInfoSlice = createSlice({
    name: 'personalInfo',
    initialState: {
        personalInfo: null
    },
    reducers: {
        setPersonalInfo: (state, action) => {
            state.personalInfo = action.payload.personalInfo
        }
    }
});
export const addPersonalInfo = personalInfoSlice.actions.setPersonalInfo;
export default personalInfoSlice.reducer;
